import facebook from 'assets/icons/socials/facebook.svg';
import instagram from 'assets/icons/socials/instagram.svg';
import twitter from 'assets/icons/socials/twitter.svg';
import tiktok from 'assets/icons/socials/tiktok.svg';

export const socials = [
  { id: 1, name: 'Facebook', link: 'https://facebook.com', icon: facebook },
  { id: 2, name: 'Instagram', link: 'https://instagram.com', icon: instagram },
  { id: 3, name: 'Twitter', link: 'https://twitter.com', icon: twitter },
  { id: 4, name: 'Tiktok', link: 'https://tiktok.com', icon: tiktok },
];
